import { useEffect, useState } from "react"
import Job from "../models/Job"
import { closeJob, getUser, hasRole, openCloseJob, openInvoicesJob, rejectJobByTech, removeJob, useHub, usePreferences } from "../../../../core/Global"
import { toastError } from "../../../../components/base/Toast"
import FlexRow from "../../../../components/base/FlexRow"
import Modal from "../../../../components/base/Modal"
import JobDrawerStatus from "./jobdrawer/JobDrawerStatus"
import JobDrawerClient from "./jobdrawer/JobDrawerClient"
import JobDrawerTech from "./jobdrawer/JobDrawerTech"
import JobDrawerAppointment from "./jobdrawer/JobDrawerAppointment"
import JobDrawerAddress from "./jobdrawer/JobDrawerAddress"
import JobDrawerTags from "./jobdrawer/JobDrawerTags"
import JobDrawerDetails from "./jobdrawer/JobDrawerDetails"
import NotesContainer from "./NotesContainer"
import JobDrawerPayments from "./jobdrawer/JobDrawerPayments"
import { UserTypes } from "../../../../core/Enums"
import Icon from "../../../../components/base/Icon"
import { API_ROUTES } from "../../../../core/Constants"
import JobRejectByTechModal from "./jobmodals/JobRejectByTechModal"
import { usePWAStatus } from "../../../../hooks/usePWAStatus"


interface IProps {
    job: Job
    sentToTechTime?: number
    height?: number
    callLink?: string
    mapLink?: string
    onWriteNote?: () => void
}
export default function JobDrawerEdit(props: IProps) {

    const user = getUser()
    const hub = useHub()
    const pref = usePreferences()



    const [noteType, noteTypeSet] = useState<string>("all");
    const [dateType, dateTypeSet] = useState<string>("default");

    const [notesRefresh, notesRefreshSet] = useState<boolean>()
    useEffect(() => {
        notesRefreshSet(true)
        setTimeout(() => {
            notesRefreshSet(false)
        }, 1000);
    }, [props.job.notesCount])


    const [accepting, acceptingSet] = useState<boolean>(false)
    const [startConfirm, startConfirmSet] = useState<boolean>(false)
    const [endConfirm, endConfirmSet] = useState<boolean>(false)

    // Start/End flow (declared after hooks — see hooks-before-consts rule): when the
    // preference is on, an accepted job must be Started then Ended by the tech before the
    // Invoice/Close actions become available.
    const startEndFlow = !!pref?.jobsPreferences?.enableTechStartEndJobFlow
    const jobStarted = !!props.job.startedAt
    const jobEnded = !!props.job.finishedAt
    const showCloseInvoice = !startEndFlow || jobEnded

    return (
        <div className="scroll-y" style={{ height: props.height }}>
            <div className="px-10 py-5">
                <JobDrawerClient job={props.job} />
            </div>

            <div className="px-10 py-5 bg-light">
                <JobDrawerStatus job={props.job} />
            </div>

            {
                props.job.isClosed && props.job.payment &&
                <div className="px-10 py-5 bg-light">
                    <JobDrawerPayments job={props.job} />
                </div>
            }

            <div className="py-5">
                <JobDrawerAddress job={props.job} mapLink={props.mapLink} />
            </div>

            <div className="px-10 py-5 bg-light">
                <JobDrawerAppointment job={props.job} />
            </div>


            {
                !user?.isTech &&
                <>
                    <div className="px-10 py-5">
                        <JobDrawerTech job={props.job} />
                    </div>
                    <div className="px-10 py-5 bg-light">
                        <JobDrawerTags job={props.job} />
                    </div>
                </>

            }




            <div className="px-10 py-5">
                <JobDrawerDetails job={props.job} />
            </div>

            {
                !user?.isTech &&
                <>
                    <div className="px-10 py-5 bg-light">
                        <FlexRow>
                            <div className="fw-bolder fs-5">
                                Latest Notes
                            </div>
                            <div className="ms-auto">
                                <select className="form-select form-select-sm w-150px ms-2"
                                    value={dateType}
                                    onChange={e => dateTypeSet(e.target.value)}
                                    style={{
                                        minHeight: "auto",
                                        fontSize: 11,
                                        lineHeight: 1.1
                                    }}>
                                    <option value="default">My Time</option>
                                    <option value="local">Local Time ({props.job.timezone})</option>
                                </select>
                            </div>
                        </FlexRow>
                    </div>


                    <div className="py-5">
                        <NotesContainer key="jobs-drawerviewedit-notes" id="job-quickview-notes"
                            job={props.job}
                            refresh={notesRefresh}
                            dateType={dateType}
                            noteType={noteType}
                            className="px-5" />
                    </div>
                </>
            }

            {
                user?.isTech && !props.job.isClosed && !props.job.isCanceled &&
                <div className="px-10 py-5">


                    {
                        props.job.techAccepted ?
                            <>

                                {
                                    startEndFlow && !jobStarted &&
                                    <button className="btn btn-success w-100 mb-3"
                                        onClick={e => {
                                            e.preventDefault()
                                            startConfirmSet(true)
                                        }}>
                                        <Icon icon="play" type="solid" className="me-2" />
                                        Start Job
                                    </button>
                                }

                                {
                                    startEndFlow && jobStarted && !jobEnded &&
                                    <button className="btn btn-dark w-100 mb-3"
                                        onClick={e => {
                                            e.preventDefault()
                                            endConfirmSet(true)
                                        }}>
                                        <Icon icon="flag-checkered" type="solid" className="me-2" />
                                        End Job
                                    </button>
                                }

                                {
                                    showCloseInvoice && (hasRole("TechCreateJobInvoice")) &&
                                    <button className="btn btn-primary w-100 mb-3"
                                        onClick={e => {
                                            e.preventDefault()
                                            openInvoicesJob(props.job)
                                        }}>
                                        <Icon icon="dollar-sign" type="solid" />
                                        Estimates & Invoices
                                    </button>
                                }

                                {
                                    showCloseInvoice && (hasRole("TechPendingCloseJob") || hasRole("TechDirectCloseJob")) &&
                                    <button className="btn btn-dark w-100 mb-3"
                                        onClick={e => {
                                            e.preventDefault()
                                            openCloseJob(props.job)
                                        }}>
                                        <Icon icon="box-archive" type="solid" className="me-2" />
                                        Close the Job
                                    </button>
                                }

                            </>
                            :
                            <>
                                <button className="btn btn-success w-100 mb-3"
                                    disabled={accepting}
                                    onClick={e => {
                                        e.preventDefault()
                                        acceptingSet(true)
                                        hub.Post(API_ROUTES.Jobs + "acceptbytech", {
                                            id: props.job.id
                                        }, res => {
                                            acceptingSet(false)
                                            if (!res.success) {
                                                // Reassigned while the app was backgrounded — drop it from the board.
                                                toastError(res.message ?? "This job is no longer assigned to you.")
                                                removeJob(props.job)
                                            }
                                        })
                                    }}>
                                    {
                                        accepting ?
                                            <>
                                                <Icon icon="spinner-third" spin />
                                                <span className="ms-2">Please wait...</span>
                                            </>
                                            :
                                            <>Accept Job</>
                                    }

                                </button>
                                <button className="btn btn-light-danger w-100 mb-3"
                                    onClick={e => {
                                        e.preventDefault()
                                        rejectJobByTech(props.job)
                                    }}>
                                    Reject Job
                                </button>
                            </>
                    }



                </div>
            }

            {
                startConfirm &&
                <Modal id="modal-startjob-confirm"
                    title="Start Job"
                    subtitle={"Job ID: " + props.job.jobId + " | " + props.job.fullName}
                    visible open
                    buttonText="Confirm & Start"
                    buttonColor="success"
                    onClose={() => startConfirmSet(false)}
                    onSubmit={(body, callback) => {
                        hub.Post(API_ROUTES.Jobs + "startbytech", {
                            id: props.job.id
                        }, res => {
                            callback?.(res)
                            if (!res.success) toastError(res.message)
                            startConfirmSet(false)
                        })
                    }}>
                    <div>
                        Are you sure you want to start this job?
                    </div>
                </Modal>
            }

            {
                endConfirm &&
                <Modal id="modal-endjob-confirm"
                    title="End Job"
                    subtitle={"Job ID: " + props.job.jobId + " | " + props.job.fullName}
                    visible open
                    buttonText="Confirm & End"
                    buttonColor="dark"
                    onClose={() => endConfirmSet(false)}
                    onSubmit={(body, callback) => {
                        hub.Post(API_ROUTES.Jobs + "endbytech", {
                            id: props.job.id
                        }, res => {
                            callback?.(res)
                            if (!res.success) toastError(res.message)
                            endConfirmSet(false)
                        })
                    }}>
                    <div>
                        Are you sure you want to end this job?
                    </div>
                </Modal>
            }

        </div>
    )
}